import {
  Box,
  Paper,
} from "@mui/material"


function FilterBar({
  children,
  columns = "minmax(220px, 2fr) repeat(2, minmax(150px, 1fr))",
  sx = {},
}) {
  return (
    <Paper
      sx={{
        p: {
          xs: 1,
          sm: 1.25,
        },
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 3,
        boxShadow: "0 4px 14px rgba(15,23,42,0.025)",
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            md: columns,
          },
          gap: 1,
          alignItems: "center",

          "& .MuiButton-root": {
            minHeight: 40,
          },
        }}
      >
        {children}
      </Box>
    </Paper>
  )
}


export default FilterBar
